import React, { useState, useEffect, useRef } from "react";
import { cleanJoin } from "../../../utils/stringUtil";

function BurgerMenu({
  backgroundBulmaColor = "black",
  dataTarget = "navigation",
  hoverBulmaColor = "warning",
  textBulmaColor = "white",
}) {
  const navigationElement = useRef(null);
  const [burgerTextColor, setBurgerTextColor] = useState("has-text-" + textBulmaColor);
  const [isOpened, setOpened] = useState(true);

  const onMouseEnter = () => setBurgerTextColor("has-text-" + hoverBulmaColor);
  const onMouseLeave = () => setBurgerTextColor("has-text-" + textBulmaColor);
  const onClick = () => {
    navigationElement.current.classList.toggle("is-active");
    setOpened(!isOpened);
  };

  useEffect(() => {
    setBurgerTextColor("has-text-" + textBulmaColor);
  }, [textBulmaColor]);

  useEffect(() => {
    navigationElement.current = document.getElementById(dataTarget);
  }, [dataTarget]);

  return (
    <button
      className={cleanJoin(
        "navbar-burger",
        "burger",
        "button",
        "is-dark",
        `has-background-${backgroundBulmaColor}`,
        burgerTextColor,
        isOpened ? "" : "is-active"
      )}
      aria-label="menu"
      aria-expanded="false"
      data-target={dataTarget}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </button>
  );
}

export default BurgerMenu;
